import { Grid, styled } from "@mui/material";
import React from "react";
import { TIPOS_MENSAJES } from "../../Constants";

const TextoStyled = styled('p')({
    backgroundColor: '#161e55',
    color: '#ffff',
    padding: '7px',
    paddingLeft: '18px',
    paddingRight: '18px',
    paddingBottom: '20px',
    borderRadius: '5px',
    margin: '10px',
    maxWidth: '19vw',
    wordWrap: 'break-word',
    position: 'relative',
    display: 'block'
})

const HoraStyled = styled('span')({
    color: '#aaa', 
    fontSize: '10px', 
    position: 'absolute', 
    bottom: '2px',
    right: '5px',
});

const InteractiveStyled = styled('p')({
    backgroundColor: '#161e55',
    color: '#ffff',
    paddingTop: '18px',
    paddingLeft: '18px',
    paddingRight: '18px',
    paddingBottom: '18px',
    borderRadius: '18px',
    margin: '10px',
    maxWidth: '19vw',
    wordWrap: 'break-word',
    position: 'relative',
    display: 'block'
})

export default function Interactive({texto, tipos, times, content}) {
    return (
        <>
        <Grid item sx={{display: 'flex', justifyContent: tipos == TIPOS_MENSAJES.enviado ? 'flex-start' : 'flex-end', width: '100%'}}>
            <TextoStyled>
                {texto}
                <HoraStyled>{times}</HoraStyled>
            </TextoStyled>
            
        </Grid>
        <Grid container sx={{display: 'flex', flexDirection: 'column', alignItems: tipos == TIPOS_MENSAJES.enviado ? 'flex-start' : 'flex-end', width: '100%'}}>
            {content.split("/").map(items => (
                <InteractiveStyled item key={items}>{items}</InteractiveStyled>
            ))}
        </Grid>
        </>
    );
    }